module.exports = __webpack_public_path__ + "media/images/logo-cf2f2e4a9896ea646cc91726dcb0d31c.svg";